var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#F7F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.4425 29.3059C58.3976 28.1383 58.3976 27.0156 58.3976 25.9377C58.3976 25.0845 57.724 24.4108 56.8707 24.4108C50.269 24.3659 45.2391 22.4797 41.0626 18.4379C40.4788 17.854 39.4907 17.854 38.9069 18.4379C34.7303 22.4797 29.7005 24.3659 23.1437 24.3659C22.2904 24.3659 21.6168 25.0396 21.6168 25.8928C21.6168 26.9707 21.6168 28.0934 21.5719 29.3059C21.3473 40.3986 21.033 55.533 39.4907 61.9102C39.6704 61.9551 39.8051 62 39.9847 62C40.1644 62 40.344 61.9551 40.4787 61.9102C58.9365 55.533 58.6222 40.3986 58.4425 29.3059Z",
    fill: "#E3E2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4423 29.306C58.3974 28.1383 58.3974 27.0156 58.3974 25.9377L25.6445 51.7072C28.2807 55.8905 32.5638 59.517 39.4905 61.9102C39.6701 61.9551 39.8049 62 39.9845 62C40.1641 62 40.3438 61.9551 40.4785 61.9102C58.9363 55.5331 58.6219 40.3986 58.4423 29.306Z",
    fill: "#D2D1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2839 34.6501L37.8739 42.0602L34.6853 38.8716C34.1015 38.2878 33.1135 38.2878 32.4847 38.8716C31.9009 39.4554 31.9009 40.4435 32.4847 41.0722L36.7511 45.3386C37.0655 45.6529 37.4248 45.7877 37.829 45.7877C38.2331 45.7877 38.6373 45.6529 38.9068 45.3386L47.4396 36.8058C48.0234 36.222 48.0234 35.234 47.4396 34.6052C46.8558 34.0214 45.8677 34.0214 45.2839 34.6501Z",
    fill: "#8E8CEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon-check.940c162aad8437e2dce8f40620b0a902.svg";
export { ForwardRef as ReactComponent };